var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid"},_vm._l((_vm.items),function(item){return _c('div',{key:item.fileid,staticClass:"item fill-block"},[_c('Folder',{attrs:{"data":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }